export default __webpack_public_path__ + "static/media/plane.669f48a9.png";